import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearAddRecordLoading,
    clearUpdateRecordError,
    clearUpdateRecordLoading,
    updateRecordFail,
    updateRecordStart,
    updateRecord,
    updateRecordSuccess,
    addRecordToBottom,
    cancelAddRecord,
    cancelUpdateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfList,
    updateInList,
    removeFromList,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LOAD_CANCELLATION_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_LOAD_CANCELLATION_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_LOAD_CANCELLATION_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_LOAD_CANCELLATION_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_LOAD_CANCELLATION_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_LOAD_CANCELLATION_LIST: return addToBottomOfList(state, action.payload);
        case actionTypes.UPDATE_IN_LOAD_CANCELLATION_LIST: return updateInList(state, action.payload);
        case actionTypes.REMOVE_FROM_LOAD_CANCELLATION_LIST: return removeFromList(state, action.payload);
        case actionTypes.FETCH_LOAD_CANCELLATION_START: return fetchRecordStart(state);
        case actionTypes.FETCH_LOAD_CANCELLATION_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_LOAD_CANCELLATION_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_LOAD_CANCELLATION: return clearRecord(state);
        case actionTypes.ADD_LOAD_CANCELLATION: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_LOAD_CANCELLATION_START: return addRecordStart(state);
        case actionTypes.ADD_LOAD_CANCELLATION_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_LOAD_CANCELLATION_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_LOAD_CANCELLATION_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_LOAD_CANCELLATION_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_LOAD_CANCELLATION_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_LOAD_CANCELLATION: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_LOAD_CANCELLATION: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_LOAD_CANCELLATION_START: return updateRecordStart(state);
        case actionTypes.UPDATE_LOAD_CANCELLATION_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_LOAD_CANCELLATION_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_LOAD_CANCELLATION_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_LOAD_CANCELLATION_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_LOAD_CANCELLATION_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_LOAD_CANCELLATION: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;